module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3Ljc1IDIuMDEyNUwxNS45ODc1IDAuMjVMOSA3LjIzNzVMMi4wMTI1IDAuMjVMMC4yNSAyLjAxMjVMNy4yMzc1IDlMMC4yNSAxNS45ODc1TDIuMDEyNSAxNy43NUw5IDEwLjc2MjVMMTUuOTg3NSAxNy43NUwxNy43NSAxNS45ODc1TDEwLjc2MjUgOUwxNy43NSAyLjAxMjVaIiBmaWxsPSIjMURCOUI5Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/close.svg
// module id = GyvE
// module chunks = 1